module.exports = __webpack_public_path__ + "static/media/IGTV-p-500.0f252e1e.png";